export default {
    documents: [],
    loading: false,
    messageLoading: '',
    showPdf: false,
    document: {},
    selected_document: {},
    data: {
        qr: null,
        cufe: null,
    },
    modal: {show: false}
};



// WEBPACK FOOTER //
// ./src/modules/send_documents/state.js